import { type FormikHelpers } from "formik";
import { apiRequest } from "shared/api/apiRequest";
import { postSocietyProfileAccountingInvoiceItemDiscountCodeStringContract } from "shared/api/contracts/society/societyId/profiles/profileId/accounting/invoice/invoiceId/item/invoiceItemId/discountCode/discountCodeString";
import PillarForm from "shared/components/pillar-form/PillarForm";
import PillarModalBody from "shared/components/pillar-modal/NewPillarModalBody";
import { useCustomSession } from "shared/context/CustomSessionContext";
import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";
import { useHubCheckoutInvoiceItemContext } from "hub/src/pages/checkout/context/HubCheckoutInvoiceItemContext";
import { getSocietyId } from "hub/src/utils/getSocietyId";

const HubCheckoutDiscountCodeModal = () => {
  const session = useCustomSession();
  const { invoiceItem, discountCodeModalControl } =
    useHubCheckoutInvoiceItemContext();
  const { invoice, refetchInvoice } = useHubCheckoutContext();
  type ApplyDiscountCodeForm = {
    discountCodeString: string;
  };

  const handleApplyDiscountCode = async (
    { discountCodeString }: ApplyDiscountCodeForm,
    formikHelpers?: FormikHelpers<ApplyDiscountCodeForm>,
  ) => {
    try {
      await apiRequest({
        contract:
          postSocietyProfileAccountingInvoiceItemDiscountCodeStringContract,
        inputs: {
          params: {
            societyId: getSocietyId(),
            profileId: session.profile!.profileId,
            invoiceId: invoice!.invoiceId!,
            invoiceItemId: invoiceItem!.invoiceItemId!,
            discountCodeString: discountCodeString,
          },
        },
      });
    } catch (e: any) {
      formikHelpers?.setStatus({ error: e.message });
      formikHelpers?.setSubmitting(false);
      return;
    }
    await refetchInvoice();
    discountCodeModalControl.setIsOpen(false);
  };
  return (
    <PillarModalBody
      control={discountCodeModalControl}
      title="Apply Discount Code"
      testid="apply-discount-code-modal"
    >
      <PillarForm<ApplyDiscountCodeForm>
        className="mt-1"
        handleSubmit={handleApplyDiscountCode}
      >
        <div className="flex flex-col items-center ">
          <PillarForm.TextInput
            name="discountCodeString"
            label="Enter Discount Code"
            testid="apply-discount-code-form-discountCodeString"
          />
          <div className="flex w-full justify-end mt-2">
            <PillarForm.LoadingSubmitButton
              label="Apply"
              className="w-full h-6"
              testid="apply-discount-code-modal-form-submit"
            />
          </div>
        </div>
      </PillarForm>
    </PillarModalBody>
  );
};

export default HubCheckoutDiscountCodeModal;
